import { CONFIG_KEYDATA_CONSTANTS } from '../core/constants';
const { DEFAULT_PV } = CONFIG_KEYDATA_CONSTANTS;

export const initialRawUnitConfig = {
	videoSectionId: '',
	videoPlayerId: 'ap-player',
	name: 'Section Name',
	createdOn: Date.now(),
	archivedOn: Date.now(),
	isArchived: false,
	videos: [],
	'networkData.dfpAdUnits.DESKTOP.defaultUnits': [],
	'networkData.dfpAdUnits.DESKTOP.backfillUnits': [],
	'networkData.dfpAdUnits.DESKTOP.noMcmUnits': [],
	'networkData.dfpAdUnits.MOBILE.defaultUnits': [],
	'networkData.dfpAdUnits.MOBILE.backfillUnits': [],
	'networkData.dfpAdUnits.MOBILE.noMcmUnits': [],
	'networkData.dfpAdUnits.TABLET.defaultUnits': [],
	'networkData.dfpAdUnits.TABLET.backfillUnits': [],
	'networkData.dfpAdUnits.TABLET.noMcmUnits': [],
	'networkData.adxOnly.enabled': false,
	'networkData.adxOnly.adXOnlyPercentage': 50,

	'networkData.hbFloorsConfig.enabled': false,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.IN': 0.32,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.US': 3.25,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.UK': 2.25,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.DE': 2.25,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.GB': 2.25,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.HK': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.KR': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.FR': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.CH': 1.75,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.BR': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.MX': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.CA': 3.25,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.AU': 3.25,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.SG': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.SA': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.AT': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.CL': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.IT': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.AE': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.NL': 1.75,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.CO': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.ES': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.AR': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.MY': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.ID': 1,
	'networkData.hbFloorsConfig.countryWiseHbFloorMapping.DEFAULT': 0.32,

	'networkData.hbFloorsConfig.useHBFloorsAsUPR': false,
	'networkData.gamUprConfig': {
		DESKTOP: {
			MACOS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			WINDOWS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			DEFAULT: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			}
		},
		MOBILE: {
			IOS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			ANDROID: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			DEFAULT: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			}
		},
		TABLET: {
			IOS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			ANDROID: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			DEFAULT: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			}
		},
		DEFAULT: {
			IOS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			ANDROID: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			MACOS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			WINDOWS: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			},
			DEFAULT: {
				countryWiseFloorMapping: {
					DEFAULT: '0.06'
				}
			}
		},
		enabled: false
	},
	'formatData.closeBtnPosition.DESKTOP': 'top-right',
	'formatData.closeBtnPosition.TABLET': 'top-right',
	'formatData.closeBtnPosition.MOBILE': 'top-right',

	'formatData.playerCustomCss.DESKTOP.rightPosition': '0px',
	'formatData.playerCustomCss.DESKTOP.rightPositionPip': '0px',
	'formatData.playerCustomCss.DESKTOP.leftPosition': '0px',
	'formatData.playerCustomCss.DESKTOP.leftPositionPip': 'auto',
	'formatData.playerCustomCss.DESKTOP.bottomPositionPip': '0px',
	'formatData.playerCustomCss.DESKTOP.topPositionPip': 'auto',
	'formatData.playerCustomCss.DESKTOP.zIndex': '1',
	'formatData.playerCustomCss.DESKTOP.zIndexPip': '9999',

	'formatData.playerCustomCss.TABLET.rightPosition': '0px',
	'formatData.playerCustomCss.TABLET.rightPositionPip': '0px',
	'formatData.playerCustomCss.TABLET.leftPosition': '0px',
	'formatData.playerCustomCss.TABLET.leftPositionPip': 'auto',
	'formatData.playerCustomCss.TABLET.bottomPositionPip': '0px',
	'formatData.playerCustomCss.TABLET.topPositionPip': 'auto',
	'formatData.playerCustomCss.TABLET.zIndex': '1',
	'formatData.playerCustomCss.TABLET.zIndexPip': '9999',

	'formatData.playerCustomCss.MOBILE.rightPosition': '0px',
	'formatData.playerCustomCss.MOBILE.rightPositionPip': '0px',
	'formatData.playerCustomCss.MOBILE.leftPosition': '0px',
	'formatData.playerCustomCss.MOBILE.leftPositionPip': 'auto',
	'formatData.playerCustomCss.MOBILE.bottomPositionPip': '0px',
	'formatData.playerCustomCss.MOBILE.topPositionPip': 'auto',
	'formatData.playerCustomCss.MOBILE.zIndex': '1',
	'formatData.playerCustomCss.MOBILE.zIndexPip': '9999',

	'formatData.maxPlayerSizes.DESKTOP.width': '640',
	'formatData.maxPlayerSizes.DESKTOP.height': '360',
	'formatData.maxPlayerSizes.MOBILE.width': '320',
	'formatData.maxPlayerSizes.MOBILE.height': '180',
	'formatData.maxPlayerSizes.TABLET.width': '320',
	'formatData.maxPlayerSizes.TABLET.height': '180',

	'formatData.floatingPlayerSizes.DESKTOP.width': '400',
	'formatData.floatingPlayerSizes.DESKTOP.height': '225',
	'formatData.floatingPlayerSizes.MOBILE.width': '256',
	'formatData.floatingPlayerSizes.MOBILE.height': '144',
	'formatData.floatingPlayerSizes.TABLET.width': '256',
	'formatData.floatingPlayerSizes.TABLET.height': '144',

	'formatData.playerAspectRatio.DESKTOP': '16/9',
	'formatData.playerAspectRatio.TABLET': '16/9',
	'formatData.playerAspectRatio.MOBILE': '16/9',

	'requestStructureData.batchedAdRequests.requestBatchSize': 5,
	'requestStructureData.batchedAdRequests.batchDelayTimeInMs': 30000,
	'requestStructureData.batchedAdRequests.requestSectionSize': 4,
	'requestStructureData.batchedAdRequests.sectionDelayTimeInMs': 30000,

	'requestStructureData.filledRetryInterval': 30000,
	'requestStructureData.unfilledRetryInterval': 10000,
	'requestStructureData.countryWiseRequestBlocking.enabled': false,
	'requestStructureData.countryWiseRequestBlocking.countryList': [
		'AO',
		'AM',
		'AT',
		'AZ',
		'BD',
		'CM',
		'CN',
		'CO',
		'CR',
		'CY',
		'EC',
		'ET',
		'FI',
		'GE',
		'GR',
		'GT',
		'IT',
		'KZ',
		'KE',
		'KW',
		'LB',
		'MA',
		'NP',
		'NG',
		'NO',
		'PK',
		'PA',
		'PY',
		'PE',
		'PL',
		'SH',
		'SN'
	],
	'requestStructureData.maxUnfilledBeforeBackfill': 0,

	'featuresData.floatingUnitConfig.enabled': false,
	'featuresData.floatingUnitConfig.DESKTOP.aboveFold': false,
	'featuresData.floatingUnitConfig.DESKTOP.belowFold': false,
	'featuresData.floatingUnitConfig.MOBILE.aboveFold': false,
	'featuresData.floatingUnitConfig.MOBILE.belowFold': false,
	'featuresData.floatingUnitConfig.TABLET.aboveFold': false,
	'featuresData.floatingUnitConfig.TABLET.belowFold': false,
	'featuresData.customTargeting.pageviewTargeting.enabled': true,
	'featuresData.customTargeting.pageviewTargeting.sec_pv_targeting': DEFAULT_PV
};

export const initialSectionLevelSplitConfig = {
	enabled: false,
	splitLevel: 'SITE_LEVEL_SPLIT',
	splits: {}
};

export const initialCustomParentToChildMapping = {
	enabled: false,
	mapping: {}
};

export const initialAggressiveVpMuteCoverageConfig = {
	enabled: false,
	splitPercentage: 100
};

export const initialTransformedGamIds = [{ value: '103512698', editable: false }];

export const initialCurrencyConfig = {
	GENIEE_JPY: {
		adServerCurrency: 'JPY',
		granularityMultiplier: 132.3076923076923
	}
};

export const initialDaisyChainObj = {
	DEFAULT: {
		enabled: false,
		defaultVastLimit: 1,
		dcVastLimit: 1,
		startWithDcVasts: false,
		initialRequestsLimit: 3,
		vastTags: []
	}
};

export const initialPrebidObj = {
	code: '[]-instream-unit',
	mediaTypes: {
		video: {
			playerSize: [640, 360],
			sizes: [
				[640, 360],
				[400, 225],
				[320, 180]
			],
			context: 'instream',
			mimes: ['video/mp4', 'video/ogg', 'video/webm', 'application/javascript'],
			protocols: [3, 6, 7, 8],
			api: [2],
			linearity: 1,
			minduration: 0,
			maxduration: 30,
			skip: 1,
			skippable: true,
			startdelay: 0,
			playbackmethod: [2, 6],
			placement: 1
		}
	},
	bids: []
};

export const initialTpVastReportingConfig = {
	demandConfiguration: {
		ADIPOLO: {
			demandPartnerCut: -150,
			reportingEnabled: true
		},
		VIDGYOR: {
			demandPartnerCut: -150,
			reportingEnabled: true
		},
		DIDNA: {
			demandPartnerCut: -150,
			reportingEnabled: true
		},
		INCREMENTX: {
			demandPartnerCut: -150,
			reportingEnabled: true
		}
	},
	tpVastReportingEnabled: true
};

export const initialPrebidBiddersConfig = {
	appnexus: {
		bidder: 'appnexus',
		params: {
			placementId: 0,
			floor: 0,
			video: {
				skippable: true,
				frameworks: [1, 2],
				playback_method: null
			}
		}
	},
	openx: {
		bidder: 'openx',
		params: {
			unit: '',
			delDomain: 'genieeintl-d.openx.net'
		}
	},
	pubmatic: {
		bidder: 'pubmatic',
		params: {
			adSlot: '',
			floor: '0',
			publisherId: '982725',
			video: {
				mimes: ['video/mp4', 'video/webm', 'application/javascript'],
				skippable: true
			}
		}
	},
	ix: {
		bidder: 'ix',
		params: {
			siteId: '',
			video: {}
		}
	},
	rubicon: {
		bidder: 'rubicon',
		params: {
			accountId: 20616,
			siteId: 432986,
			video: {
				api: [1, 2],
				linearity: 1,
				maxduration: 30,
				mimes: ['video/mp4', 'video/x-ms-wmv', 'application/javascript', 'video/webm'],
				playerHeight: '480',
				playerWidth: '640',
				protocols: [2, 3, 5, 6]
			},
			zoneId: 0
		}
	},
	sharethrough: {
		bidder: 'sharethrough',
		params: {
			pkey: ''
		}
	},
	smartadserver: {
		bidder: 'smartadserver',
		params: {
			siteId: 0,
			pageId: 0,
			formatId: 105838
		}
	},
	sonobi: {
		bidder: 'sonobi',
		params: {
			placement_id: ''
		}
	},
	triplelift: {
		bidder: 'triplelift',
		params: {
			inventoryCode: '',
			video: {
				h: 180,
				w: 320
			}
		}
	},
	sovrn: {
		bidder: 'sovrn',
		params: {
			tagid: ''
		}
	},
	amx: {
		bidder: 'amx',
		params: {
			tagId: ''
		}
	},
	criteo: {
		bidder: 'criteo',
		params: {
			networkId: '9125',
			zoneId: ''
		}
	},
	rise: {
		bidder: 'rise',
		params: {
			org: ''
		}
	},
	nextMillennium: {
		bidder: 'nextMillennium',
		params: {
			placement_id: ''
		}
	},
	grid: {
		bidder: 'grid',
		params: {
			uid: ''
		}
	},
	vidazoo: {
		bidder: 'vidazoo',
		params: {
			cId: '64c7d6d6f0dba81d51b6b33f',
			pId: '59ac17c192832d0011283fe3',
			bidFloor: 0.1,
			subDomain: 'prebid'
		}
	},
	minutemedia: {
		bidder: 'minutemedia',
		params: {
			org: '01gfqhccg436'
		}
	},
	unruly: {
		bidder: 'unruly',
		params: {
			siteId: 264052
		}
	},
	vidoomy: { bidder: 'vidoomy', params: { id: '', pid: '' } },
	eplanning: {
		bidder: 'eplanning',
		params: {
			ci: ''
		}
	},
	mediafuse: {
		bidder: 'mediafuse',
		params: {
			placementId: 0
		}
	},
	pulsepoint: {
		bidder: 'pulsepoint',
		params: {
			cp: 0,
			ct: 0,
			video: {
				mimes: ['video/mp4', 'video/webm', 'application/javascript'],
				skippable: true
			}
		}
	},
	nobid: {
		bidder: 'nobid',
		params: {
			siteId: 0,
			placementId: 0
		}
	},
	insticator: {
		bidder: 'insticator',
		params: {
			adUnitId: ''
		}
	},
	kueezrtb: {
		bidder: 'kueezrtb',
		params: {
			cId: '66a146b79e9ebeaa9abe688a',
			pId: '65lk7c192882r0011813fn9'
		}
	},
	impactify: {
		bidder: 'impactify',
		params: {
			appId: '',
			format: 'screen',
			style: 'inline'
		}
	},
	adagio: {
		bidder: 'adagio',
		params: {
			organizationId: '',
			placement: '',
			site: '',
			adUnitElementId: 'RON',
			pagetype: 'article',
			category: 'sport'
		}
	}
};

export const initialbvsConfig = {
	'featuresData.bannerReplacementConfig.enabled': false,
	'featuresData.bannerReplacementConfig.platforms.DESKTOP.enabled': false,
	'featuresData.bannerReplacementConfig.platforms.MOBILE.enabled': false,
	'featuresData.bannerReplacementConfig.platforms.TABLET.enabled': false
};

export const initialVideoToBannerSwitchInContentConfig = {
	'featuresData.bannerInContentAdConfig.DESKTOP.enabled': false,
	'featuresData.bannerInContentAdConfig.DESKTOP.keepFloatingRestSession': false,
	'featuresData.bannerInContentAdConfig.MOBILE.enabled': false,
	'featuresData.bannerInContentAdConfig.MOBILE.keepFloatingRestSession': false,
	'featuresData.bannerInContentAdConfig.TABLET.enabled': false,
	'featuresData.bannerInContentAdConfig.TABLET.keepFloatingRestSession': false
};

export const initialCompanionAdConfig = {
	'networkData.apCompanionAds.enabled': false,
	'networkData.apCompanionAds.DESKTOP.enabled': false,
	'networkData.apCompanionAds.MOBILE.enabled': false,
	'networkData.apCompanionAds.TABLET.enabled': false
};

export const initialOverlayAdsConfig = {
	'networkData.apOverlayAds.enabled': false,
	'networkData.apOverlayAds.DESKTOP.enabled': false,
	'networkData.apOverlayAds.MOBILE.enabled': false,
	'networkData.apOverlayAds.TABLET.enabled': false
};

export const initialHybridAdsConfig = {
	'networkData.apOutstreamHybridAds.enabled': false,
	'networkData.apOutstreamHybridAds.DESKTOP.enabled': false,
	'networkData.apOutstreamHybridAds.MOBILE.enabled': false,
	'networkData.apOutstreamHybridAds.TABLET.enabled': false
};

export const initialBannerFpConfig = {
	siteId: 0,
	siteDomain: 'dummydomain',
	floorPriceConfig: {
		enabled: false,
		loggingVersion: 0,
		trafficSplit: 0,
		floorEngineTypeSplit: []
	},
	configs: []
};
export const initialFvpSiteConfig = {
	siteId: 0,
	siteDomain: '',
	ads: {}
};

export const initialFvpSectionConfig = {
	videoSectionId: '',
	videoSectionName: '',
	'networkData.demandSequence': [],
	'networkData.demandSelectionOrder': 'SEQUENTIAL',
	'networkData.globalHbDisabled': false,
	'networkData.hbFloor': 0.5,
	'networkData.uamConfig.enabled': false,
	'networkData.uamConfig.publisherId': '2e7e1587-d92f-46dd-8721-80b53eccb87e',
	'networkData.uamConfig.uamSlotId': 'Adpushup_Instream',
	'requestStructureData.filledRetryInterval': 500,
	'requestStructureData.unfilledRetryInterval': 500,
	'requestStructureData.requestBatchSize': 10,
	'requestStructureData.maxNumberOfBatches': 2,
	'featuresData.unmuteAfterInteractionConfig.enabled': false
};

export const getInitialSplitDocConfig = (siteId, siteDomain) => {
	return {
		siteId,
		enabled: false,
		siteDomain,
		scripts: {
			FRAMERATE: {
				type: 'URL',
				value: `https://cdn.adpushup.com/${siteId}/apInstreamBundle.js`,
				defer: false,
				async: false
			}
		},
		splitConfigs: {
			GLOBAL_PLATFORM: {
				GLOBAL_COUNTRY: {
					archived: false,
					splits: [
						{
							key: 'FRAMERATE',
							split: 100
						}
					]
				}
			}
		}
	};
};

export const initialExpbSiteConfig = {
	blockers: [],
	additionalSiteAccessEmails: [],
	experiments: []
};

export const getInitialAbSplitTestConfig = (splitType, counterpartSectionRef) => {
	return {
		splitType,
		counterpartSectionRef
	};
};

export const initialUnsyncedDfpAdUnitObj = {
	sectionName: '',
	adUnitName: '',
	sectionId: '',
	isThirdPartyDFP: false,
	platform: '',
	type: ''
};

export const initialContentMappingObj = {
	mode: 'MAP_YT_PLAYLIST',
	category: '',
	playlistName: '',
	isPublic: false,
	processStatus: 'INITIALISED',
	subCategory: '',
	unmutedVideosList: [],
	mutedVideosList: [],
	uploadMuted: false,
	activeAudioVersion: 'unmuted'
};

export const initialAdUnitAndVastDetailsObj = {
	adUnitName: '',
	gamCode: '',
	sectionId: '',
	floorPrice: '',
	customParams: '',
	enableForLiveTraffic: false,
	enableChildNetwork: false,
	videoFormatType: '',
	sizes: [],
	descriptionUrl: '',
	adDuration: 15
};
